import * as React from "react";
import { render } from "react-dom";
import "antd-min";
import router from "./config/router";
import { reducers } from "./reducers/index";
import { AppBase, CookieBanner, GLGlobal, isRussiaDomain, polyfillSupport, WrongTenantRedirectModal } from "gl-commonui";
import {
    masterPagesDefined,
    registerDatePickerLocale,
    RestrictedPaths,
    UserType,
} from "./util/index";
import "./util/binds";
import "./style/index.less";
import "./style/fonts.config.less";
import states from "./states";
import { intlLoaded } from "./locales/index";

// apply Wijmo license key
import { setLicenseKey } from "wijmo/wijmo";
import PrivacyPolicy from "./page/privacypolicy/privacypolicy";

polyfillSupport().then(async () => {
    registerDatePickerLocale();
    setLicenseKey('*.grapecity.net|*.grapecitydev.com|*.grapeseed.app|*.grapeseed.com|*.grapeseed.ru|*.grapeseed.us,483555874441165#B0ZNtgDNiojIklkIs4XXbpjInxmZiwiIxYXNyAjMiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TUZJzL7MUOUpHNGRmav5Eb5Jka8E7bZRHdYVVaOlkNmNUOxIlN4Vzb85mb5U7QlFGV5l5KyhXUGNXO6E6Y5EmTvNFeihFdEV6czQGWBtGT9k4SWtGR6gFU9MENT5mUI9UMIZEbNpWZ9NWSPxWRjZ5ZzVEVIdVc5N6ZVlndJVEZ8gEVFx6buFDakx4SmFVTKhXOipVWk3GVVZUaTZDWvolevokbHJTQ52CZBhTZlV5NxlVUX5mWv2kc6tESQdjR6sCVB5GdMp4ZptkSGNTTGhzawI4QVpFRlJEeqV5NHdDWI3GNIdHcLlnU9cDVONlTVtGbSFnNC3WYzkmTxdXTXN5bCB7dBlnTzE6a5JmbRdTTw5GaFZEMCpWc8klewJVQ5pGeUhld9Inb5gFdZlldolkUSZkSEx4KyYENnV5UzMnTPZUMQVTc6wEd8J5aFZmMjFUdrkjYr4kI0IyUiwiIFZEM7QkRERjI0ICSiwiM9YDM5kzNzcTM0IicfJye#4Xfd5nIJBjMSJiOiMkIsIibvl6cuVGd8VEIgQXZlh6U8VGbGBybtpWaXJiOi8kI1xSfiUTSOFlI0IyQiwiIu3Waz9WZ4hXRgAicldXZpZFdy3GclJFIv5mapdlI0IiTisHL3JyS7gDSiojIDJCLi86bpNnblRHeFBCI73mUpRHb55EIv5mapdlI0IiTisHL3JCNGZDRiojIDJCLi86bpNnblRHeFBCIQFETPBCIv5mapdlI0IiTisHL3JyMDBjQiojIDJCLiUmcvNEIv5mapdlI0IiTisHL3JSV8cTQiojIDJCLi86bpNnblRHeFBCI4JXYoNEbhl6YuFmbpZEIv5mapdlI0IiTis7W0ICZyBlIsISNycTN8ADI4IjMwYjMwIjI0ICdyNkIsIyc59CZlV6clBXYydmLqwSdy9CZlV6clBXYydmLqwSbvNmLkVWZzVGchJ7ZuoCLwBXYuQWZlNXZwFmcn9iKs46bj9idlRWe4l6YlBXYydmLqwCdl9mL9RXajVGchJ7ZuoiI0IyctRkIsICZ4xEIhlGZl5EIEVURTVGchJ7RiojIh94QiwiI5YTMxQDN4c2OdU');

    const restrictedPaths = Object.values(RestrictedPaths);
    const isRestrictedPage = restrictedPaths.some((path) =>
        window.location.pathname.includes(path)
    );

    render(
        <AppBase
            masterPagesDefined={masterPagesDefined}
            states={states}
            reducers={reducers}
            intlLoaded={intlLoaded}
        >
            <WrongTenantRedirectModal />
            {!isRestrictedPage && (
                <PrivacyPolicy
                    userType={UserType.Existing}
                    delayMilliSeconds={2000}
                ></PrivacyPolicy>
            )}
            {isRussiaDomain() && !isRestrictedPage && <CookieBanner />}
            {router}
        </AppBase>,
        document.getElementById("app_content")
    );
});
